import React from "react";
import { Container, Row, Col } from "@ui/wrapper";
import Line from "@ui/divider/line";
import { SectionWrap } from "./style";

const DividerSection = () => {
	return (
		<SectionWrap>
			<Container>
				<Row>
					<Col lg={12}>
						<Line mt="40px" mb="40px" style={{borderColor:"black"}} />
					</Col>
				</Row>
			</Container>
		</SectionWrap>
	)
}	

export default DividerSection
